import { Action } from 'redux-actions';
import { all, put, takeLatest } from 'redux-saga/effects';

import { logCritical } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { executeSagaRequest } from '@savgroup-front-common/core/services';

import { getClaimDocumentsRequest } from '../../api/Claim/getClaimDocumentsQuery';

import { GET_DOCUMENTS_BY_CLAIM_ID } from './actionTypes';

interface GetDocumentsByClaimIdPayload {
  claimId: string;
}

function* getDocumentsByClaimIdWorker({
  payload,
}: {
  payload: GetDocumentsByClaimIdPayload;
}): Generator {
  const { claimId } = payload;
  const meta = { claimId, indexer: claimId };

  yield executeSagaRequest(
    GET_DOCUMENTS_BY_CLAIM_ID,
    getClaimDocumentsRequest({ claimId }),
    meta,
  );

  yield put(GET_DOCUMENTS_BY_CLAIM_ID.end(meta));
}
function* getDocumentsByClaimIdWatcher() {
  yield takeLatest<Action<GetDocumentsByClaimIdPayload>>(
    GET_DOCUMENTS_BY_CLAIM_ID.BASE,
    getDocumentsByClaimIdWorker,
  );
}

export default function* mainSaga() {
  try {
    yield all([getDocumentsByClaimIdWatcher()]);
  } catch (error) {
    logCritical(error);
  }
}
